import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import ValidationForm from 'components/ui/ValidationForm';
import Field from 'components/ui/Field';
import { ConfirmButton, ActionButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';
import { CurrencyInput } from 'components/ui/Inputs';
import { Errors } from '../../SplitPayment/SplitPayment.styles';

export const validAccountNumber = (number) => /^(\w|\d){6}$/.test(number);
export const validPostcode = (postcode) => /^(\w|\d){5,7}$/.test(postcode.replace(/\s/g, ''));

const AccountForm = ({
  amount,
  currency,
  disablePayment,
  onUpdateAmount,
  performQuery,
  loading,
  paymentUrlPrefix,
  isSplitPayment,
  totalPriceToBePaid
}) => (
  <ValidationForm
    validators={{
      amount: (values) => (isSplitPayment ? Number(values.amount) > 0 && Number(values.amount) <= totalPriceToBePaid : true),
      accountNumber: (values) => validAccountNumber(values.accountNumber),
      postcode: (values) => validPostcode(values.postcode)
    }}
    fields={{
      accountNumber: '',
      postcode: '',
      amount
    }}
    overrideFields={{ amount }}
    validateInitialFields
  >
    {({ fields, onChange, hasInvalidInputs, touchedInputs, invalidInputs }) => (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          performQuery({
            accountNumber: fields.accountNumber,
            postcode: fields.postcode
          });
        }}
      >
        <Row span={16}>
          <Row span={10}>
            {isSplitPayment && (
              <>
                <CurrencyInput
                  value={fields.amount}
                  disabled={disablePayment}
                  currency={currency}
                  name="amount"
                  onChange={(event) => {
                    onChange(event);
                    onUpdateAmount(event.target.value);
                  }}
                />
                <Errors>
                  {invalidInputs.amount && Number(fields.amount) === 0 && <FormattedMessage id="payments.amountZero" />}
                  {invalidInputs.amount && Number(fields.amount) !== 0 && <FormattedMessage id="payments.amountTooLarge" />}
                </Errors>
              </>
            )}
            <Field
              onChange={onChange}
              value={fields.accountNumber}
              name="accountNumber"
              label="baf.bafCode"
              hasError={touchedInputs.accountNumber && invalidInputs.accountNumber}
              errorMessage="baf.invalidAccountNumber"
            />
            <Field
              onChange={onChange}
              value={fields.postcode}
              name="postcode"
              label="baf.enterPostcode"
              hasError={touchedInputs.postcode && invalidInputs.postcode}
              errorMessage="baf.invalidPostcode"
            />
          </Row>
        </Row>
        <Row span={16}>
          <Row span={7}>
            <ConfirmButton loading={loading} disabled={!fields.accountNumber || !fields.postcode || hasInvalidInputs} type="submit">
              <FormattedMessage id="baf.check" />
            </ConfirmButton>
          </Row>
          {!isSplitPayment && (
            <Row span={7}>
              <ActionButton element={<Link to={paymentUrlPrefix} />}>
                <FormattedMessage id="payment.chooseMethod" />
              </ActionButton>
            </Row>
          )}
        </Row>
      </form>
    )}
  </ValidationForm>
);

AccountForm.propTypes = {
  amount: PropTypes.number,
  currency: PropTypes.string,
  disablePayment: PropTypes.bool,
  onUpdateAmount: PropTypes.func,
  totalPriceToBePaid: PropTypes.number,
  performQuery: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  paymentUrlPrefix: PropTypes.string.isRequired,
  isSplitPayment: PropTypes.bool
};

AccountForm.defaultProps = {
  isSplitPayment: false,
  onUpdateAmount: () => {}
};

export default AccountForm;
